// Api
import Starlight from 'Starlight'

// Constants
import { SITE_KEYWORDS, SITE_DESCRIPTION } from 'constants/tags'

// Components
import Layout from 'components/Layout'
import Projects from 'components/Projects'
import SectionHeader from 'components/SectionHeader'


const Projetos = ({ project, projects, header, footer }) => {
  const { metatag_description, metatag_keywords, title, description, dark } = project?.data?.data

  return (
    <Layout
      dark={dark}
      header={header}
      footer={footer}
      metaTags={{
        title: 'JS Studio | Projetos',
        description: metatag_description ?? SITE_DESCRIPTION,
        keywords: metatag_keywords ?? SITE_KEYWORDS
      }}
    >
      <SectionHeader isFirstElement dark={dark} title={title} description={description}/>
      <Projects dark={dark} projects={projects}/>
    </Layout>
  )
}

export async function getServerSideProps() {
  const [ project, projects ] = await Promise.all([
    Starlight.singletons.get('projects'),
    Starlight.entries.list('projetos', {o: 'published_at:asc'})
  ])

  const data = {
    project: project || { },
    projects: projects || [ ]
  }

  return { 
    props: {
      ...data
    }
  }
}

export default Projetos
